<template>
    <section class="app-main">
            <el-card class="m-bottom-4" v-if="goods.purchase_title">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品名称：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="goods.purchase_title" placeholder="加湿器" style="width:400px" readonly></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        产品所属：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="goods.belongs" placeholder="MOOBYYOHO" style="width:400px" readonly></el-input>
                    </el-col>
                </el-row>  
                <el-row class="m-bottom-2">
                    <el-col :span="2" class="input-left">
                        商品主图：
                    </el-col>
                    <el-col :span="22">
                        <el-image :src="goods.purchase_pic_url" style="width:200px;height:200px"></el-image>
                    </el-col>
                </el-row>
            </el-card>

            <div v-if="goods.specs" >
                <el-card class="m-bottom-4" v-for="(it,i) in goods.specs" :key="i">
                    <el-row class="m-bottom-2">
                        <el-col :span="2" class="input-left">
                            商品规格：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="it.attr_symbol_string" placeholder="红色-L" class="sku-input" readonly></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-2">
                        <el-col :span="2" class="input-left">
                            进货价格：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="it.price"  @change="handleChange(it,1)"  placeholder="0.00" class="sku-input">
                                <span slot="suffix" class="sku-price">￥</span>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-42">
                        <el-col :span="2" class="input-left">
                            进货数量：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="it.number"  @change="handleChange(it,2)" clearable  placeholder="1" class="sku-input"></el-input>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            
            <el-card v-if="goods.purchase_title">
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        提交商品：
                    </el-col>
                    <el-col :span="22">
                        <el-button  @click="handleCancel()" type="info"    plain style="width:150px">取消下单</el-button>
                        <el-button  @click="handleSubmit()" type="success" plain style="width:150px">确认下单</el-button>
                    </el-col>
                </el-row>
            </el-card>
        
    </section>
</template>
<script>
import { purchase_list, purchase_edit, purchase_confirm, purchase_cancel } from '@/api/buy.js'
export default {
    name:'buyOrder',
    data () {
        return {
            goods:{},
        }
    },
    methods:{

        // 获取下单商品
        handleData(){
            this.goods = {};
            purchase_list(0,{belongs: 2}).then(res => {
                if(res) {
                    this.goods = res.data.data[0]
                }
                
            })
        },

        // 填写单个规格的 进货价格 进货数量
        handleChange(it,number){
            let params = {}
            if (number == 1) {
                params.price = it.price
            }else {
                params.number = it.number
            }
            purchase_edit(it.id,params).then(res => {  
                if(res){
                    this.$message.success(res.msg)
                }
            })
        },

        // 取消下单
        handleCancel(){
            purchase_cancel(this.goods.id).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.handleData() 
                }
            })
        },

        handleSubmit(){
            purchase_confirm(this.goods.id).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.handleData() 
                }
            })
        },

 
    },

    created(){
        this.handleData()
    },
    activated() {
        this.handleData()
    },

}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .sku-price {
        height: 40px;
        line-height: 42.5px;
        width: 30px;
        text-align: center;
    }
    .sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
}
</style>

